/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// Chart.js v4 - No need for manual Rectangle drawing
// Rounded corners are now handled via borderRadius option in Chart.js v4

var mode = "light"; //(themeMode) ? themeMode : 'light';
var fonts = {
  base: "Open Sans"
};

// Colors
var colors = {
  gray: {
    100: "#f6f9fc",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#8898aa",
    700: "#525f7f",
    800: "#32325d",
    900: "#212529"
  },
  theme: {
    default: "#172b4d",
    primary: "#5e72e4",
    secondary: "#f4f5f7",
    info: "#11cdef",
    success: "#2dce89",
    danger: "#f5365c",
    warning: "#fb6340"
  },
  black: "#12263F",
  white: "#FFFFFF",
  transparent: "transparent"
};

// Methods

// Chart.js v4 global options (simplified - modern API doesn't need complex global defaults)
function chartOptions() {
  // Chart.js v4 uses a different structure
  // Most options are now set directly on chart instances
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 16,
          color: mode === "dark" ? colors.gray[700] : colors.gray[600],
          font: {
            family: fonts.base,
            size: 13
          }
        }
      },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false
      }
    },
    elements: {
      point: {
        radius: 0,
        backgroundColor: colors.theme["primary"]
      },
      line: {
        tension: 0.4,
        borderWidth: 4,
        borderColor: colors.theme["primary"],
        backgroundColor: colors.transparent,
        borderCapStyle: "round"
      },
      bar: {
        backgroundColor: colors.theme["warning"],
        borderRadius: 6,
        borderSkipped: false
      },
      arc: {
        backgroundColor: colors.theme["primary"],
        borderColor: mode === "dark" ? colors.gray[800] : colors.white,
        borderWidth: 4
      }
    }
  };
}

// Parse global options (Chart.js v4 - simplified, options are set on Chart.defaults)
function parseOptions(Chart, options) {
  // In Chart.js v4, we directly set defaults
  if (options && Chart && Chart.defaults) {
    Object.assign(Chart.defaults, options);
  }
}

// Example 1 of Chart inside src/views/Index.jsx (Sales value - Card)
let chartExample1 = {
  options: {
    scales: {
      y: {
        grid: {
          color: colors.gray[900],
          borderDash: [2],
          borderDashOffset: 2,
          drawBorder: false,
          drawTicks: false
        },
        ticks: {
          callback: function(value) {
            if (!(value % 10)) {
              return "$" + value + "k";
            }
          },
          padding: 10
        }
      },
      x: {
        grid: {
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false
        },
        ticks: {
          padding: 20
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            var label = context.dataset.label || "";
            var content = "";

            if (label) {
              content += label + ": ";
            }

            content += "$" + context.parsed.y + "k";
            return content;
          }
        }
      }
    }
  },
  data1: canvas => {
    return {
      labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      datasets: [
        {
          label: "Performance",
          data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
          borderColor: colors.theme["primary"],
          backgroundColor: colors.transparent
        }
      ]
    };
  },
  data2: canvas => {
    return {
      labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      datasets: [
        {
          label: "Performance",
          data: [0, 20, 5, 25, 10, 30, 15, 40, 40],
          borderColor: colors.theme["primary"],
          backgroundColor: colors.transparent
        }
      ]
    };
  }
};

// Example 2 of Chart inside src/views/Index.jsx (Total orders - Card)
let chartExample2 = {
  options: {
    scales: {
      y: {
        ticks: {
          callback: function(value) {
            if (!(value % 10)) {
              return value;
            }
          }
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            var label = context.dataset.label || "";
            var content = "";
            if (label) {
              content += label + ": ";
            }
            content += context.parsed.y;
            return content;
          }
        }
      }
    }
  },
  data: {
    labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Sales",
        data: [25, 20, 30, 22, 17, 29],
        backgroundColor: colors.theme["warning"],
        borderRadius: 6
      }
    ]
  }
};

module.exports = {
  chartOptions, // used inside src/views/Index.jsx
  parseOptions, // used inside src/views/Index.jsx
  chartExample1, // used inside src/views/Index.jsx
  chartExample2 // used inside src/views/Index.jsx
};
